"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submit = void 0;
const tslib_1 = require("tslib");
const bridge_1 = require("../bridge");
const errors_1 = require("../errors");
const callBridge = (0, bridge_1.getCallBridge)();
const submit = (payload) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const success = yield callBridge('submit', payload);
    if (success === false) {
        throw new errors_1.BridgeAPIError("this resource's view is not submittable.");
    }
});
exports.submit = submit;
